import PageComponent from '/root/workspace/JiaMeiHuiBackstage_3hGC/src/pages/index/index';

const PageComponentName = PageComponent;

export default PageComponentName;
